import type { Crop, CropType } from "../types";
import { type ActionResponse, fetchTable } from "@/services/baseApi";

// Función para obtener todos los tipos de cultivos
export async function fetchCropTypes(): Promise<ActionResponse<CropType[]>> {
  // baseApi (fetchTable) ya loggea el error; no se vuelve a loggear aquí.
  return fetchTable<CropType>("crop_types", {
    select: "*",
    orderBy: "name"
  });
}

// Función para obtener todos los cultivos
export async function fetchCrops(): Promise<ActionResponse<Crop[]>> {
  // baseApi (fetchTable) ya loggea el error; no se vuelve a loggear aquí.
  return fetchTable<Crop>("crops", {
    select: "*",
    orderBy: "name"
  });
}
